import mixCutDetailStore from "@/stores/mixCutDetailStore";
import { IOrigin } from "@/stores/mixCutDetailStore/type";
import { toJS } from "mobx";
import useMixCutDetailInit from "./useMixCutDetailInit";
import {
  getToSencesInitTransitionItem,
  initCaptionItem,
  toIndexGetInitTitleTextSetting,
} from "@/stores/mixCutDetailStore/init";
import previewConfing from "@/stores/previewStore";
import clipIdStore from "@/stores/previewStore/clipId";
import { v4 as uuid } from "uuid";
import Trasnsition from "@/pages/VideoClips/MixCutDetail/Transition/Transition";
import useTransition from "./useTransition";
import ConfigStore from '@/stores/mixedConfig'
// 获取所有json
// 开始是否global
// 设置ProjectMsg
const useMixCutDetail = () => {
  const { initGlobleCaptionGroup, initTitleGroup } = useMixCutDetailInit();
  const handelProjectGlobalChange = (e: boolean) => {
    mixCutDetailStore.setProjectIsGolbal(e);
  };
  const toggleGlobaltoItem = () => {
    previewConfing.setCaption(null);
    previewConfing.setTitle(null);
    clipIdStore.setClipId(null);
    mixCutDetailStore.setProjectIsGolbal(false);
    mixCutDetailStore.setTransition(null);
    ConfigStore.global_settings.enabled = false;
    ConfigStore.global_settings.transition = null;
    (ConfigStore.scenes || []).forEach((_, index) => {
      if (index === 0) {
        mixCutDetailStore.setProjectCaption([
          [
            {
              id: Math.floor(Date.now() + Math.random() * 100000),
              ...initCaptionItem,
            },
          ],
        ]);
        mixCutDetailStore.setProTitle([
          {
            id: Math.floor(Date.now() + Math.random() * 100000),
            is_global: false,
            content: [
              {
                id: Math.floor(Date.now() + Math.random() * 100000),
                text: "",
                _text: [
                  {
                    type: "paragraph",
                    content: [
                      {
                        type: "text",
                        text: "",
                      },
                    ],
                  },
                ],
                text_setting: { ...toIndexGetInitTitleTextSetting(0) },
              },
            ],
          },
        ]);
      } else {
        const titles = mixCutDetailStore.getProjectTitle();
        const captions = mixCutDetailStore.getProjectCaption();
        mixCutDetailStore.setProTitle([
          ...titles,
          {
            id: Math.floor(Date.now() + Math.random() * 100000),
            is_global: false,
            content: [
              {
                id: Math.floor(Date.now() + Math.random() * 100000),
                text: "",
                _text: [
                  {
                    type: "paragraph",
                    content: [
                      {
                        type: "text",
                        text: "",
                      },
                    ],
                  },
                ],
                text_setting: { ...toIndexGetInitTitleTextSetting(0) },
              },
            ],
          },
        ]);
        mixCutDetailStore.setProjectCaption([
          ...captions,
          [
            {
              id: Math.floor(Date.now() + Math.random() * 100000),
              ...initCaptionItem,
            },
          ],
        ]);
      }
      if (
        index !== 0 ||
        index !== ConfigStore.scenes.length
      ) {
        const transition = mixCutDetailStore.getTransition();
        mixCutDetailStore.setTransition({
          ...transition,
          ...getToSencesInitTransitionItem(index),
        });
      }
    });
  };

  const toggleItemtoGlobal = () => {
    mixCutDetailStore.setProjectIsGolbal(true);
    mixCutDetailStore.setProjectGlobalTransition({
      duration: 500,
      effects: [],
    });
    initGlobleCaptionGroup();
    initTitleGroup();
    previewConfing.setCaption(null);
    previewConfing.setTitle(null);
    clipIdStore.setClipId(null);
    const transition = {};
    ConfigStore.scenes.map((item, index) => {
      if (index > 0) {
        const [key, value] = Object.entries(
          getToSencesInitTransitionItem(index - 1),
        )[0];
        transition[key] = value;
      }
    });
    mixCutDetailStore.setTransition(transition);
    ConfigStore.global_settings.enabled = true;
    ConfigStore.global_settings.transition = {
      duration: 500,
      effects: [],
    };
    ConfigStore.transition = transition;
  };

  const handleGetOriginJson = (): IOrigin => {
    const _materials = {};
    (
      Object.keys(mixCutDetailStore.getProjectMaterialsInfo() || {}) || []
    ).forEach((item) => {
      _materials[item] = {
        url: "",
        cover: "",
      };
    });
    return {
      version: ConfigStore.version || "1.0.0",
      _materials,
      scenes: ConfigStore.scenes?.map((item, index) => {
        return {
          id: item.id || uuid(),
          name: item.name,
          setting: item.setting,
          materials: item.materials.map((item) => {
            return {
              ...item,
              speed: 1,
            };
          }),
          caption: (mixCutDetailStore.getProjectCaption() || [])[index],
          title: (mixCutDetailStore.getProjectTitle() || [])[index],
        };
      }) || [],
      transition: ConfigStore.transition,
      global_settings: {
        keywords: ConfigStore.global_settings.keywords,
        keywords_id: ConfigStore.global_settings.keywords_id,
        enabled: ConfigStore.global_settings.enabled,
        titles: ConfigStore.global_settings.titles,
        captions: ConfigStore.global_settings.captions,
        transition: ConfigStore.global_settings.transition,
        cover: {
          images: toJS(ConfigStore.global_settings.cover),
        },
        background: {
          audio: ConfigStore.global_settings.background.audio,
          color: toJS(ConfigStore.global_settings.background.color),
          images: toJS(ConfigStore.global_settings.background.images),
          audio_volume: ConfigStore.global_settings.background.audio_volume || 50,
          blur: {
            radius: ConfigStore.global_settings.background.blur.radius,
          }
        },
        decorations: ConfigStore.global_settings.decorations
      },
    };
  };

  return {
    global: ConfigStore.global_settings.enabled,
    handelProjectGlobalChange,
    handleGetOriginJson,
    handleProjectMsgSet: mixCutDetailStore.setProjectMsg,
    projectMsg: mixCutDetailStore.getProjectMsg(),
    toggleGlobaltoItem,
    toggleItemtoGlobal,
  };
};

export default useMixCutDetail;
